import React from 'react';
import TopicLayout from '../Js_files/Topic_layout';
import Navbar from './Navbar';
import Footer from './Footer';
import { useEffect, useState } from 'react';
import EnrollForm from './Enroll';


const File2 = () => {
   const [showScrollTop, setShowScrollTop] = useState(false);
    const [showForm, setShowForm] = useState(false); // ✅ Control form visibility
             useEffect(() => {
          const handleScroll = () => {
            setShowScrollTop(window.scrollY > 200);
          };
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
        }, []);
      
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
  const topics = [
    {
      title: "Structural Engineering",
      description: "Design and analysis of buildings, bridges, and other structures. Learn about load calculations, material properties, and structural safety.",
      tags: ["Concrete", "Steel", "Load Analysis", "Safety"]
    },
    {
      title: "Construction Management",
      description: "Project planning, scheduling, and management of construction projects from conception to completion.",
      tags: ["Project Planning", "Scheduling", "Cost Control", "Safety Management"]
    },
    {
      title: "Geotechnical Engineering",
      description: "Study of soil mechanics, foundation design, and earth structures for stable construction.",
      tags: ["Soil Mechanics", "Foundations", "Slope Stability", "Ground Improvement"]
    },
    {
      title: "Transportation Engineering",
      description: "Design and planning of transportation systems including roads, highways, and traffic management.",
      tags: ["Highway Design", "Traffic Flow", "Pavement", "Urban Planning"]
    },
    {
      title: "Water Resources",
      description: "Management of water systems, hydraulic structures, and environmental water engineering.",
      tags: ["Hydrology", "Water Treatment", "Dams", "Irrigation"]
    },
    {
      title: "Environmental Engineering",
      description: "Sustainable construction practices, waste management, and environmental impact assessment.",
      tags: ["Sustainability", "Waste Management", "Green Building", "Impact Assessment"]
    }
  ];

  const resources = [
    {
      icon: "📐",
      title: "Design Software",
      description: "CAD tools like AutoCAD Civil 3D, Revit, and structural analysis software for civil engineering projects."
    },
    {
      icon: "🏗️",
      title: "Construction Guides",
      description: "Building codes, construction standards, and best practices for safe and efficient construction."
    },
    {
      icon: "🌍",
      title: "Case Studies",
      description: "Real-world infrastructure projects and their engineering solutions from around the world."
    },
    {
      icon: "📊",
      title: "Analysis Tools",
      description: "Structural analysis software, project management tools, and engineering calculation programs."
    }
  ];

  const careerPaths = [
    {
      title: "Structural Engineer",
      description: "Design and analyze structures ensuring they can safely support loads and withstand environmental conditions.",
      skills: ["Structural Analysis", "Design Codes", "CAD Software", "Material Knowledge"]
    },
    {
      title: "Construction Manager",
      description: "Oversee construction projects, manage teams, budgets, and ensure projects are completed on time and within budget.",
      skills: ["Project Management", "Leadership", "Cost Control", "Scheduling"]
    },
    {
      title: "Transportation Planner",
      description: "Plan and design transportation systems to improve traffic flow and accessibility in urban and rural areas.",
      skills: ["Traffic Analysis", "Urban Planning", "GIS", "Policy Development"]
    },
    {
      title: "Environmental Consultant",
      description: "Assess environmental impact of construction projects and develop sustainable engineering solutions.",
      skills: ["Environmental Assessment", "Sustainability", "Regulations", "Report Writing"]
    }
  ];

  return (
    <>
      <Navbar onEnrollClick={() => setShowForm(true)}/>
    <TopicLayout
      title="Civil Engineering"
      icon="🏗️"
      color="#4ECDC4"
      description="Dive into structural engineering, construction techniques, and infrastructure development. Learn about sustainable building practices, urban planning, and the engineering marvels that shape our cities."
      topics={topics}
      resources={resources}
      careerPaths={careerPaths}
    />
    <Footer/>

     <a
        href="https://wa.me/9042857947"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      {/* Scroll to Top */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}

      {/* ✅ Enroll Form Overlay */}
      {showForm && <EnrollForm onClose={() => setShowForm(false)} />}
    </>
  );
};

export default File2;